import React from "react";
import * as Yup from "yup";
import { Input } from "antd";

import i18n from "../../../../../../i18n";
import { Field, FormConfig } from "../../../../../controls/FormikForm";
import AnswerInput from "../../inputs/AnswerInput";
import Button from "../../../../../Button";

import { leaveInterceptor } from "./selectors";

import styled from "styled-components/macro";

const Row = styled.div`
  display: flex;
`;

const Column = styled.div`
  flex: 1;

  & + & {
    margin-left: 24px;
  }

  .answer,
  .tag {
    border-left: 5px solid ${({ theme }) => theme["@primary"]};
  }

  .message {
    border-left: 5px solid ${({ theme }) => theme["@grey-darker"]};
  }
`;

const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
`;

const validationSchema = Yup.object().shape({
  answer: Yup.string().required(i18n.t("form:emptyFieldValidation")),
  message: Yup.string().required(i18n.t("form:emptyFieldValidation")),
  tag: Yup.string()
});

const initialValues = {
  answer: "",
  message: "",
  tag: ""
};

const OptionForm = ({ t, onSubmit, onClose }) => {
  function handleSubmit(values) {
    onSubmit(leaveInterceptor(values));
    onClose();
  }

  return (
    <FormConfig
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ isValid, handleSubmit }) => (
        <form
          data-test="optionsForm"
          onSubmit={event => {
            event.stopPropagation();
            handleSubmit(event);
          }}
        >
          <Row>
            <Column>
              <Field
                autoFocus
                name="answer"
                label={t("opportunity:process.stepTypes.chatbot.tree.answer")}
                help={t(
                  "opportunity:process.stepTypes.chatbot.tree.answerSupportedChars"
                )}
              >
                <AnswerInput t={t} className="answer" />
              </Field>
              <Field
                name="message"
                label={t("opportunity:process.stepTypes.chatbot.tree.message")}
              >
                <Input className="message" />
              </Field>
              <Field
                name="tag"
                label={t("opportunity:process.stepTypes.chatbot.tree.tag")}
              >
                <Input className="tag" />
              </Field>
            </Column>
          </Row>
          <Footer>
            <Button
              style={{ marginRight: 12 }}
              htmlType="button"
              type="quaternary"
              onClick={onClose}
            >
              {t("global:cancel")}
            </Button>
            <Button htmlType="submit" type="primary" disabled={!isValid}>
              {t("opportunity:process.stepTypes.chatbot.tree.addBranch")}
            </Button>
          </Footer>
        </form>
      )}
    </FormConfig>
  );
};

export default OptionForm;
